import { useTranslation } from 'react-i18next';
import './crosssTitle.scss'
import { callGTMAnalytics } from '../../helper/analyticsTag';
import utagObjectAtom from '../../recoils/useUtagObject/utagObjectAtom';
import { useRecoilState } from 'recoil';
interface IProp {
  searchQuery: string;
}

const CrossTitleFeedback: React.FC<IProp> = ({ searchQuery }) => {
  const { t } = useTranslation();
  const [utagData] = useRecoilState(utagObjectAtom);
  return (
    <div className="cross-title-container">
      <h1 className="cross-title" id="cross-title">
        {t('xref-h1')}
      </h1>
      <a
        href={`https://feedback.digikey.com/jfe/form/SV_ekZ6xvJDGrPXQhM${
          searchQuery.trim()
            ? '?MfrPartNumber=' + encodeURIComponent(searchQuery)
            : ''
        }`}
        className="dk-btn__secondary feedback-button"
        target="_blank"
        type="button"
        rel="noreferrer"
        track-data="ref_page_event=Feedback and Suggestions"
        onClick={()=>callGTMAnalytics(utagData, "Feedback and Suggestions")}
      >
        {t('xref-feedback-and-suggestions')}
      </a>
    </div>
  );
};

export default CrossTitleFeedback;
